<div class="modal-header border-bottom">
  <h3 class="modal-title">
    <span>
      Thay đổi số điện thoại
    </span>
  </h3>
  <button class="btn-close close" type="button" aria-label="Close" (click)="this.activeModal.close()">
    <span class="fal fa-times" aria-hidden="true">
    </span>
  </button>
</div>

@switch (this.CURRENT_STEP) {
@case ('inputEmailStep') {
<app-input-phone-form [spinner]="true" (nextStep)="this.onSubmitEmail($event)"
  (previousStep)="this.activeModal.close()" />
}

@case ('inputOtpStep') {
<app-input-otp [emailAddress]="this.currentEmailAddress" (previousStep)="this.CURRENT_STEP = 'inputEmailStep'"
  (nextStep)="this.CURRENT_STEP = ''">
</app-input-otp>
}
@default {
<app-change-phone-success />
}
}
